import {
  CASE_UPDATE_FILE_VERSIONS_BEGIN,
  CASE_UPDATE_FILE_VERSIONS_SUCCESS,
  CASE_UPDATE_FILE_VERSIONS_FAILURE,
  CASE_UPDATE_FILE_VERSIONS_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const updateFileVersions = createPromiseAction(CASE_UPDATE_FILE_VERSIONS_BEGIN);

export function dismissUpdateFileVersionsFeedback() {
  return {
    type: CASE_UPDATE_FILE_VERSIONS_DISMISS_FEEDBACK,
  };
}

export function* doUpdateFileVersions(action) {
  const { caseId, fileId, versions } = action.payload;

  let res = yield call(
    api.put,
    `/cases/${caseId}/files/${fileId}/versions?includeAll=true`,
    versions,
  );

  if (res && res.error) {
    yield put({
      type: CASE_UPDATE_FILE_VERSIONS_FAILURE,
      feedback: {
        message: 'feedback.UpdateFileVersionsFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_UPDATE_FILE_VERSIONS_SUCCESS,
    data: { fileVersions: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchUpdateFileVersions() {
  yield takeLatest(updateFileVersions, withCurrentCaseId(doUpdateFileVersions));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_UPDATE_FILE_VERSIONS_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        updateFileVersionsPending: true,
        updateFileVersionsFeedback: null,
      };

    case CASE_UPDATE_FILE_VERSIONS_SUCCESS:
      // The request is success
      return {
        ...state,
        updateFileVersionsPending: false,
        updateFileVersionsFeedback: action.feedback,
      };

    case CASE_UPDATE_FILE_VERSIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        updateFileVersionsPending: false,
        updateFileVersionsFeedback: action.feedback,
      };

    case CASE_UPDATE_FILE_VERSIONS_DISMISS_FEEDBACK:
      // Dismiss the request failure Feedback
      return {
        ...state,
        updateFileVersionsFeedback: null,
      };

    default:
      return state;
  }
}
